// extracted by mini-css-extract-plugin
export default {"content_list":"index_content_list_cwppv","chip_item":"index_chip_item_-NWQW"};